function initTabbedContent() {
  const sections = document.querySelectorAll("[data-tabbed-content]");
  if (!sections.length) return;

  sections.forEach((section) => {
    if (section.dataset.initialized === "true") return;
    section.dataset.initialized = "true";
    new TabbedContent(section);
  });
}

class TabbedContent {
  constructor(root) {
    this.root = root;
    this.tabButtons = Array.from(
      root.querySelectorAll("[data-tabbed-content-tab]")
    );
    this.panels = Array.from(root.querySelectorAll(".c-tabbed-content__panel"));
    this.bindTabs();
    this.bindNestedPanels();
    this.syncInitialState();
  }

  bindTabs() {
    this.tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.activateTab(button.dataset.tabbedContentTab);
      });
    });
  }

  activateTab(tabKey) {
    this.tabButtons.forEach((button) => {
      const isActive = button.dataset.tabbedContentTab === tabKey;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-selected", String(isActive));
    });

    this.panels.forEach((panel) => {
      const isActive = panel.id.endsWith(`-${tabKey}`);
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });
  }

  syncInitialState() {
    const activeButton =
      this.tabButtons.find((button) =>
        button.classList.contains("is-active")
      ) || this.tabButtons[0];

    if (activeButton) {
      this.activateTab(activeButton.dataset.tabbedContentTab);
    }

    const nestedPanelKeys = new Set(
      Array.from(
        this.root.querySelectorAll("[data-tabbed-content-item-trigger]")
      ).map((trigger) => trigger.dataset.tabbedContentItemTrigger)
    );

    nestedPanelKeys.forEach((panelKey) => {
      const triggers = Array.from(
        this.root.querySelectorAll(
          `[data-tabbed-content-item-trigger="${panelKey}"]`
        )
      );
      const activeTrigger =
        triggers.find((trigger) => trigger.classList.contains("is-active")) ||
        triggers[0];

      if (activeTrigger) {
        this.activateNestedPanel(
          panelKey,
          activeTrigger.dataset.tabbedContentItemIndex
        );
      }
    });
  }

  bindNestedPanels() {
    const triggers = this.root.querySelectorAll(
      "[data-tabbed-content-item-trigger]"
    );
    if (!triggers.length) return;

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const panelKey = trigger.dataset.tabbedContentItemTrigger;
        const itemIndex = trigger.dataset.tabbedContentItemIndex;
        this.activateNestedPanel(panelKey, itemIndex);
      });
    });
  }

  activateNestedPanel(panelKey, itemIndex) {
    const triggers = this.root.querySelectorAll(
      `[data-tabbed-content-item-trigger="${panelKey}"]`
    );
    const panels = this.root.querySelectorAll(
      `[data-tabbed-content-item-panel="${panelKey}"]`
    );

    triggers.forEach((trigger) => {
      const isActive = trigger.dataset.tabbedContentItemIndex === itemIndex;
      trigger.classList.toggle("is-active", isActive);
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.tabbedContentItemIndex === itemIndex;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });
  }
}

initTabbedContent();
